import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Download, FileText, Table, Image } from 'lucide-react';

export const Resources = () => {
  const { t } = useLanguage();

  const resources = [
    {
      title: t.resources.catalog,
      description: t.resources.downloadDescriptions[0],
      icon: FileText,
      type: 'PDF',
      size: '2.5 MB'
    },
    // {
    //   title: t.resources.ifu,
    //   description: t.resources.downloadDescriptions[1],
    //   icon: FileText,
    //   type: 'PDF',
    //   size: '1.8 MB'
    // },
    // {
    //   title: t.resources.logTemplate,
    //   description: t.language === 'en' 
    //     ? 'Excel template for recording sterilization monitoring results'
    //     : 'แม่แบบ Excel สำหรับบันทึกผลการเฝ้าระวังการทำให้ปราศจากเชื้อ',
    //   icon: Table,
    //   type: 'XLSX',
    //   size: '45 KB'
    // },
    {
      title: t.resources.colorChart,
      description: t.resources.downloadDescriptions[2],
      icon: Image,
      type: 'PNG/PDF',
      size: '3.2 MB'
    }
  ];

  const handleDownload = (resourceTitle: string) => {
    // Placeholder for download functionality
    console.log(`Download ${resourceTitle}`);
  };

  return (
    <section id="resources" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t.resources.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.resources.description}
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary mx-auto mt-6 rounded-full" />
        </div>

        {/* Resources Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {resources.map((resource, index) => {
            const IconComponent = resource.icon;
            return (
              <Card key={index} className="hover:shadow-lg transition-all duration-300 hover:scale-105 border-0 shadow-md">
                <CardHeader className="text-center pb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="w-8 h-8 text-primary" />
                  </div>
                  <CardTitle className="text-lg font-bold text-gray-900 leading-tight">
                    {resource.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 text-sm">
                    {resource.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="text-center space-y-4">
                  <div className="flex justify-center gap-4 text-xs text-gray-500">
                    <span className="bg-gray-100 px-2 py-1 rounded">{resource.type}</span>
                    <span className="bg-gray-100 px-2 py-1 rounded">{resource.size}</span>
                  </div>

                  <Button
                    onClick={() => handleDownload(resource.title)}
                    className="w-full bg-primary hover:bg-primary/90 text-white"
                  >
                    <Download className="w-4 h-4 mr-2" />
                    {t.resources.downloadButton}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Resources */}
        {/* <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-2xl p-8">
          <div className="text-center space-y-6">
            <h3 className="text-2xl font-bold text-gray-900">
              {t.language === 'en' ? 'Need Additional Resources?' : 'ต้องการทรัพยากรเพิ่มเติม?'}
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
              {t.language === 'en'
                ? 'Our technical team can provide customized documentation, training materials, and implementation guides tailored to your specific needs.'
                : 'ทีมเทคนิคของเราสามารถจัดหาเอกสารที่กำหนดเอง วัสดุการฝึกอบรม และคู่มือการใช้งานที่ปรับแต่งตามความต้องการเฉพาะของคุณ'
              }
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                onClick={() => {
                  const element = document.querySelector('#contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="bg-primary hover:bg-primary/90 text-white"
              >
                {t.language === 'en' ? 'Request Custom Resources' : 'ขอทรัพยากรที่กำหนดเอง'}
              </Button>

              <Button
                variant="outline"
                onClick={() => console.log('Technical support')}
                className="border-primary text-primary hover:bg-primary hover:text-white"
              >
                {t.language === 'en' ? 'Technical Support' : 'การสนับสนุนด้านเทคนิค'}
              </Button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};